// treeExpansion.ts — localStorage 기반 사이드바 트리 접기 상태 관리.
// localStorage 키: locker.expandedGroups (JSON 직렬화 배열)
// Phase 2.5 IndexedDB 마이그레이션 시 이 모듈만 교체하면 됨.

const STORAGE_KEY = 'locker.expandedGroups';

/**
 * localStorage에서 확장된 그룹 ID 집합을 읽는다.
 * 값이 없거나 파싱 실패 시 빈 Set 반환.
 */
export function getExpandedIds(): Set<number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set<number>();
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set<number>();
    return new Set<number>(arr.filter((x): x is number => typeof x === 'number'));
  } catch {
    return new Set<number>();
  }
}

/**
 * 특정 그룹의 확장 여부를 localStorage에 저장한다.
 * @param id 그룹 ID
 * @param expanded true = 펼침, false = 접힘
 */
export function setExpanded(id: number, expanded: boolean): void {
  const ids = getExpandedIds();
  if (expanded) {
    ids.add(id);
  } else {
    ids.delete(id);
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    // localStorage 쓰기 실패(용량 초과 등) — 메모리 상태는 유지, 영속화만 실패
  }
}

/**
 * 주어진 ID 목록을 모두 확장 상태로 일괄 저장한다.
 * 검색 시 매칭된 조상들을 자동 펼칠 때 사용.
 * @param ids 펼칠 그룹 ID 배열
 */
export function expandAncestors(ids: number[]): void {
  const current = getExpandedIds();
  for (const id of ids) {
    current.add(id);
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...current]));
  } catch {
    // 쓰기 실패 무시
  }
}
